import React from 'react';

const Footer = () => {
  return <footer className='bg-primary py-12 '>
    <div className='container mx-auto'>
      <p className='text-white text-center . All rights reserved. '>Copyright &copy;  NIYATI GUPTA 2023. All Rights Reserved</p>
    </div>

  </footer>;
};

export default Footer;
